export const magdalenaSmorowska = {
    'meta': {
        'title': 'Psychoterapeuta Magdalena Smorowska • Centrum COLLIGO',
        'description': 'Psychoterapeuta uzależnień, pracujący z osobami dorosłymi, psycholog, psychoonkolog. Prowadzi terapie indywidualne jak i grupowe.'
    },
    'url': {
        'address': '/torun/zespol/psychoterapeuta-magdalena-smorowska/'
    },
    'opengraph': {
        'image': {
            'url': '/images/team/open-graph/magdalena-smorowska.webp',
            'width': 150,
            'height': 150,
            'alt': 'Psychoterapeuta Magdalena Smorowska'
        }
    }
}